export const timeZones = [
    {
        id: 1,
        value: "Etc/GMT+12",
        dif: -12,
        name: "(GMT-12:00) International Date Line West"
    },
    {
        value: "Pacific/Midway",
        dif: -11,
        name: "(GMT-11:00) Midway Island, Samoa"
    },
    {
        value: "Pacific/Honolulu",
        dif: -10,
        name: "(GMT-10:00) Hawaii"
    },
    {
        value: "US/Alaska",
        dif: -9,
        name: "(GMT-09:00) Alaska"
    },
    {
        value: "America/Los_Angeles",
        dif: -8,
        name: "(GMT-08:00) Pacific Time (US & Canada)"
    },
    {
        value: "America/Tijuana",
        dif: -8,
        name: "(GMT-08:00) Tijuana, Baja California"
    },
    {
        value: "US/Arizona",
        dif: -7,
        name: "(GMT-07:00) Arizona"
    },
    {
        value: "America/Chihuahua",
        dif: -7,
        name: "(GMT-07:00) Chihuahua, La Paz, Mazatlan"
    },
    {
        value: "US/Mountain",
        dif: -7,
        name: "(GMT-07:00) Mountain Time (US & Canada)"
    },
    {
        value: "America/Managua",
        dif: -6,
        name: "(GMT-06:00) Central America"
    },
    {
        value: "US/Central",
        dif: -6,
        name: "(GMT-06:00) Central Time (US & Canada)"
    },
    {
        value: "America/Mexico_City",
        dif: -6,
        name: "(GMT-06:00) Guadalajara, Mexico City, Monterrey"
    },
    {
        value: "Canada/Saskatchewan",
        dif: -6,
        name: "(GMT-06:00) Saskatchewan"
    },
    {
        value: "America/Bogota",
        dif: -5,
        name: "(GMT-05:00) Bogota, Lima, Quito, Rio Branco"
    },
    {
        value: "US/Eastern",
        dif: -5,
        name: "(GMT-05:00) Eastern Time (US & Canada)"
    },
    {
        value: "US/East-Indiana",
        dif: -5,
        name: "(GMT-05:00) Indiana (East)"
    },
    {
        value: "Canada/Atlantic",
        dif: -4,
        name: "(GMT-04:00) Atlantic Time (Canada)"
    },
    {
        value: "America/Caracas",
        dif: -4,
        name: "(GMT-04:00) Caracas, La Paz"
    },
    {
        value: "America/Manaus",
        dif: -4,
        name: "(GMT-04:00) Manaus"
    },
    {
        value: "America/Santiago",
        dif: -4,
        name: "(GMT-04:00) Santiago"
    },
    {
        value: "Canada/Newfoundland",
        dif: -3,
        name: "(GMT-03:30) Newfoundland"
    },
    {
        value: "America/Sao_Paulo",
        dif: -3,
        name: "(GMT-03:00) Brasilia"
    },
    {
        value: "America/Argentina/Buenos_Aires",
        dif: -3,
        name: "(GMT-03:00) Buenos Aires, Georgetown"
    },
    {
        value: "America/Godthab",
        dif: -3,
        name: "(GMT-03:00) Greenland"
    },
    {
        value: "America/Montevideo",
        dif: -3,
        name: "(GMT-03:00) Montevideo"
    },
    {
        value: "America/Noronha",
        dif: -2,
        name: "(GMT-02:00) Mid-Atlantic"
    },
    {
        value: "Atlantic/Cape_Verde",
        dif: -1,
        name: "(GMT-01:00) Cape Verde Is."
    },
    {
        value: "Atlantic/Azores",
        dif: -1,
        name: "(GMT-01:00) Azores"
    },
    {
        value: "Africa/Casablanca",
        dif: 0,
        name: "(GMT+00:00) Casablanca, Monrovia, Reykjavik"
    },
    {
        value: "Etc/Greenwich",
        dif: 0,
        name: "(GMT+00:00) Greenwich Mean Time : Dublin, Edinburgh, Lisbon, London"
    },
    {
        value: "Europe/Amsterdam",
        dif: 1,
        name: "(GMT+01:00) Amsterdam, Berlin, Bern, Rome, Stockholm, Vienna"
    },
    {
        value: "Europe/Belgrade",
        dif: 1,
        name: "(GMT+01:00) Belgrade, Bratislava, Budapest, Ljubljana, Prague"
    },
    {
        value: "Europe/Brussels",
        dif: 1,
        name: "(GMT+01:00) Brussels, Copenhagen, Madrid, Paris"
    },
    {
        value: "Europe/Sarajevo",
        dif: 1,
        name: "(GMT+01:00) Sarajevo, Skopje, Warsaw, Zagreb"
    },
    {
        value: "Africa/Lagos",
        dif: 1,
        name: "(GMT+01:00) West Central Africa"
    },
    {
        value: "Asia/Amman",
        dif: 2,
        name: "(GMT+02:00) Amman"
    },
    {
        value: "Europe/Athens",
        dif: 2,
        name: "(GMT+02:00) Athens, Bucharest, Istanbul"
    },
    {
        value: "Asia/Beirut",
        dif: 2,
        name: "(GMT+02:00) Beirut"
    },
    {
        value: "Africa/Cairo",
        dif: 2,
        name: "(GMT+02:00) Cairo"
    },
    {
        value: "Africa/Harare",
        dif: 2,
        name: "(GMT+02:00) Harare, Pretoria"
    },
    {
        value: "Europe/Helsinki",
        dif: 2,
        name: "(GMT+02:00) Helsinki, Kyiv, Riga, Sofia, Tallinn, Vilnius"
    },
    {
        value: "Asia/Jerusalem",
        dif: 2,
        name: "(GMT+02:00) Jerusalem"
    },
    {
        value: "Europe/Minsk",
        dif: 2,
        name: "(GMT+02:00) Minsk"
    },
    {
        value: "Africa/Windhoek",
        dif: 2,
        name: "(GMT+02:00) Windhoek"
    },
    {
        value: "Asia/Kuwait",
        dif: 3,
        name: "(GMT+03:00) Kuwait, Riyadh, Baghdad"
    },
    {
        value: "Europe/Moscow",
        dif: 3,
        name: "(GMT+03:00) Moscow, St. Petersburg, Volgograd"
    },
    {
        value: "Africa/Nairobi",
        dif: 3,
        name: "(GMT+03:00) Nairobi"
    },
    {
        value: "Asia/Tbilisi",
        dif: 3,
        name: "(GMT+03:00) Tbilisi"
    },
    {
        value: "Asia/Tehran",
        dif: 3.5,
        name: "(GMT+03:30) Tehran"
    },
    {
        value: "Asia/Muscat",
        dif: 4,
        name: "(GMT+04:00) Abu Dhabi, Muscat"
    },
    {
        value: "Asia/Baku",
        dif: 4,
        name: "(GMT+04:00) Baku"
    },
    {
        value: "Asia/Yerevan",
        dif: 4,
        name: "(GMT+04:00) Yerevan"
    },
    {
        value: "Asia/Kabul",
        dif: 4.5,
        name: "(GMT+04:30) Kabul"
    },
    {
        value: "Asia/Yekaterinburg",
        dif: 5,
        name: "(GMT+05:00) Yekaterinburg"
    },
    {
        value: "Asia/Karachi",
        dif: 5,
        name: "(GMT+05:00) Islamabad, Karachi, Tashkent"
    },
    {
        value: "Asia/Calcutta",
        dif: 5.5,
        name: "(GMT+05:30) Chennai, Kolkata, Mumbai, New Delhi"
    },
    {
        value: "Asia/Calcutta",
        dif: 5.5,
        name: "(GMT+05:30) Sri Jayawardenapura"
    },
    {
        value: "Asia/Katmandu",
        dif: 5.75,
        name: "(GMT+05:45) Kathmandu"
    },
    {
        value: "Asia/Almaty",
        dif: 6,
        name: "(GMT+06:00) Almaty, Novosibirsk"
    },
    {
        value: "Asia/Dhaka",
        dif: 6,
        name: "(GMT+06:00) Astana, Dhaka"
    },
    {
        value: "Asia/Rangoon",
        dif: 6.5,
        name: "(GMT+06:30) Yangon (Rangoon)"
    },
    {
        value: "Asia/Bangkok",
        dif: 7,
        name: "(GMT+07:00) Bangkok, Hanoi, Jakarta"
    },
    {
        value: "Asia/Krasnoyarsk",
        dif: 7,
        name: "(GMT+07:00) Krasnoyarsk"
    },
    {
        value: "Asia/Hong_Kong",
        dif: 8,
        name: "(GMT+08:00) Beijing, Chongqing, Hong Kong, Urumqi"
    },
    {
        value: "Asia/Kuala_Lumpur",
        dif: 8,
        name: "(GMT+08:00) Kuala Lumpur, Singapore"
    },
    {
        value: "Asia/Irkutsk",
        dif: 8,
        name: "(GMT+08:00) Irkutsk, Ulaan Bataar"
    },
    {
        value: "Australia/Perth",
        dif: 8,
        name: "(GMT+08:00) Perth"
    },
    {
        value: "Asia/Taipei",
        dif: 8,
        name: "(GMT+08:00) Taipei"
    },
    {
        value: "Asia/Tokyo",
        dif: 9,
        name: "(GMT+09:00) Osaka, Sapporo, Tokyo"
    },
    {
        value: "Asia/Seoul",
        dif: 9,
        name: "(GMT+09:00) Seoul"
    },
    {
        value: "Asia/Yakutsk",
        dif: 9,
        name: "(GMT+09:00) Yakutsk"
    },
    {
        value: "Australia/Adelaide",
        dif: 9.5,
        name: "(GMT+09:30) Adelaide"
    },
    {
        value: "Australia/Darwin",
        dif: 9.5,
        name: "(GMT+09:30) Darwin"
    },
    {
        value: "Australia/Brisbane",
        dif: 10,
        name: "(GMT+10:00) Brisbane"
    },
    {
        value: "Australia/Canberra",
        dif: 10,
        name: "(GMT+10:00) Canberra, Melbourne, Sydney"
    },
    {
        value: "Australia/Hobart",
        dif: 10,
        name: "(GMT+10:00) Hobart"
    },
    {
        value: "Australia/Hobart",
        dif: 10,
        name: "(GMT+10:00) Hobart"
    },
    {
        value: "Pacific/Guam",
        dif: 10,
        name: "(GMT+10:00) Guam, Port Moresby"
    },
    {
        value: "Asia/Vladivostok",
        dif: 10,
        name: "(GMT+10:00) Vladivostok"
    },
    {
        value: "Asia/Magadan",
        dif: 11,
        name: "(GMT+11:00) Magadan, Solomon Is., New Caledonia"
    },
    {
        value: "Pacific/Auckland",
        dif: 12,
        name: "(GMT+12:00) Auckland, Wellington"
    },
    {
        value: "Pacific/Fiji",
        dif: 12,
        name: "(GMT+12:00) Fiji, Kamchatka, Marshall Is."
    },
    {
        value: "Pacific/Tongatapu",
        dif: 13,
        name: "(GMT+13:00) Nuku'alofa"
    }
]